import { createLucideIcon, LucideIcon, LucideProps } from "lucide-react"
import React from "react"
import { ReactNode } from "react"

/**
 * Lucide only officially supports stroke color,
 * so we create an internal icon that uses stroke color and we export one that maps the stroke color to the fill color.
 */

const path = "M2 21c0-4 0-8 2-10 2-2 2 1 4 1 2 0 2-7 7-7 3 0 6 3 7 10 L2 21"

const IFill: LucideIcon = createLucideIcon("stroke", [
  ["path", { key: "p", d: path, stroke: "none" }],
  // very soft thing stroke, just so edges of light colors are visible
  [
    "path",
    { key: "s", d: path, stroke: "solid", strokeWidth: ".3", opacity: ".2" },
  ],
])

export const Fill: LucideIcon = React.forwardRef(function Fill(
  { color, ...props }: LucideProps,
  forwardedRef,
): ReactNode {
  return <IFill ref={forwardedRef} fill={color} {...props} />
})

export const Fill2 = createLucideIcon("fill2", [
  [
    "path",
    {
      key: "p",
      d: "M2 21c0-4 0-8 2-10 2-2 2 1 4 1 2 0 2-7 7-7 3 0 6 3 7 10 L2 21",
    },
  ],
])
